import React from 'react'
import { RecoilRoot } from 'recoil'

// eslint-disable-next-line react/display-name
export const withRecoil = (component: () => React.ReactNode) => () => {
  return <RecoilRoot>{component()}</RecoilRoot>
}
